import type { LoginCredentials } from '@/types/domain'

type ValidationResult =
  | { ok: true }
  | { ok: false; message: string }

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateLoginCredentials(
  credentials: LoginCredentials,
): ValidationResult {
  const email = credentials.email.trim()
  const password = credentials.password

  if (!email) {
    return { ok: false, message: 'Email is required.' }
  }

  if (!EMAIL_PATTERN.test(email)) {
    return { ok: false, message: 'Enter a valid email address.' }
  }

  if (!password) {
    return { ok: false, message: 'Password is required.' }
  }

  if (password.length < 8) {
    return { ok: false, message: 'Password must be at least 8 characters.' }
  }

  return { ok: true }
}
